import React, { useEffect, useState } from "react";
import "./SidebarBrand.css";
import OptimizelyLogo from "../apps/icons/OptimizelyLogo";
import API_URL from "../../apiConfig";
import PlanDetailsModal from "../planDetailsModal/PlanDetailsModal";
import { TeamMembersService } from "../../services/teamMembers/teamMembersService";
import Loader from "../../components/common/Loader/Loader";
import { UserService } from "../../services/user/userService";
import { UserSubscriptionDisplayModel } from "../../types/user/userSubscriptionDisplayModel";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserId } from "../../utils/tokenUtils";

interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  hasOptimizelyApp?: boolean;
}

interface TabDef {
  name: string;
  key: string;
  icon?: string;
  activeIcon?: string;
}

const Sidebar: React.FC<SidebarProps> = ({ activeTab, setActiveTab, hasOptimizelyApp = false }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [userSubscription, setUserSubscription] = useState<
    UserSubscriptionDisplayModel[]
  >([]);
  const navigate = useNavigate();
  const location = useLocation();
  const handleViewDetails = async () => {
    const userId = getUserId();

    try {
      setShowDetails(true);
    } catch (error) {
    }
  };
  const tabs: TabDef[] = [
    {
      name: "Dashboard",
      key: "dashboard",
      icon: "/images/Dashboard.svg",
      activeIcon: "/images/Dashboardcolor.svg",
    },
    {
      name: "Brand Guidelines",
      key: "brand",
      icon: "/images/BrandVoicecolor.svg",
      activeIcon: "/images/BrandVoice.svg",
    },
    {
      name: "Tasks",
      key: "tasks",
      icon: "/images/Taskcolor.svg",
      activeIcon: "/images/Tasks.svg",
    },
    ...(hasOptimizelyApp
      ? [{ name: "Optimizely", key: "optimizely" }]
      : []),
    {
      name: "History",
      key: "taskhistory",
      icon: "/images/History.svg",
      activeIcon: "/images/Taskhistorycolor.svg",
    },
  ];
  const [loading, setLoading] = useState(true);
  const [userId] = useState(getUserId() );
  useEffect(() => {
    const fetchUserPlan = async () => {
      setLoading(true); // ✅ ensure loading starts
      try {
        const subscriptionInfoResponse = await UserService.getUserSubscription(
          userId
        );
        if (
          subscriptionInfoResponse.status === 200 &&
          subscriptionInfoResponse.data
        ) {
          setUserSubscription(subscriptionInfoResponse.data);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchUserPlan();
  }, [userId]);

  const handleLogoClick = () => {
    // Detect base path (admin or user)
    const basePath = location.pathname.startsWith("/admin")
      ? "/admin/dashboard"
      : "/user/dashboard";

    navigate(basePath);
  };

  if (loading) return <Loader />;
  return (
    <aside className="sidebar">
      <img
        src="/images/Helens.svg"
        alt="Helen Logo"
        className="logo"
        onClick={handleLogoClick}
      />

      <div className="tab-container">
        <nav>
          <ul>
            {tabs.map((tab) => (
              <li
                key={tab.key}
                className={`tab-item ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.key === "optimizely" ? (
                  <OptimizelyLogo
                    size={20}
                    className={`tab-icon ${activeTab === tab.key ? "" : "tab-icon-inactive"}`}
                  />
                ) : (
                  <img
                    src={activeTab === tab.key ? tab.activeIcon : tab.icon}
                    alt={`${tab.name} Icon`}
                    className="tab-icon"
                  />
                )}
                <span>{tab.name}</span>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="tabs-two">
        <div className="plan-info">
          <div className="plan-list">
            {userSubscription &&
              Array.isArray(userSubscription) &&
              userSubscription
                ?.filter((x) => x.isActive)
                .map((subInfo) => (
                  <div className="plan-row">
                    <img
                      src="/images/Plan.svg"
                      alt="Plan Icon"
                      className="plan-icon"
                    />
                    <div className="plan-title">
                      <p className="plan-name">
                        {subInfo?.planName || "No Plan"}
                      </p>
                    </div>
                  </div>
                ))}
            {userSubscription.length === 0 && (
              <div className="plan-row">
                <img
                  src="/images/Plan.svg"
                  alt="Plan Icon"
                  className="plan-icon"
                />
                <div className="plan-title">
                  <p className="plan-type">No Plan Description</p>
                </div>
              </div>
            )}
            {/* CASE 2: Subscription exists but none are active → EXPIRED */}
            {userSubscription.length > 0 &&
              !userSubscription.some((sub) => sub.isActive) && (
                <div className="plan-row">
                  <img
                    src="/images/Plan.svg"
                    alt="Plan Icon"
                    className="plan-icon"
                  />
                  <div className="plan-title">
                    <p className="plan-name">Subscription Expired</p>
                  </div>
                </div>
              )}
          </div>
          <div className="divider_sidebar"></div>

          <div className="credit-usage">
            <button className="view-details" onClick={handleViewDetails}>
              View Details
            </button>

            {userSubscription && (
              <PlanDetailsModal
                isOpen={showDetails}
                onClose={() => setShowDetails(false)}
                subscriptionInfo={userSubscription}
                isMasterMode={true}
              />
            )}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
